<template>
<div>
    <base-header :pageName="titl" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="promotionWrap">
            <img v-for="item in fileList" :key="item.dtptSqno" :src="item.cdnUrl" alt="">
        </div>
    </section>
</div>
</template>

<script>
export default {
  name: "promotion",
  data() {
      return{
        sqno: '',
        titl: '',
        fileList: [],
      };
  },
  created: function() {
    var that = this; 
    var parameters = {
        sqno: this.$route.query.sqno,
    };
    this.$api.eduplan.promotion(parameters).then(function(data) {
        var promotion = data;

        that.sqno = promotion.sqno;
        that.titl = promotion.titl;
        that.fileList = that.fileList.concat(promotion.fileList);
    })
    .catch(function(error) {
        alert(error.rtMsg);
    });
  },
};
</script>
